import React, {useState} from "react";
import {Table, Col} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {DatePickerWithPeriod} from "../../_defaultComponents/FilterComponents";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";
import {CourierShiftTableContainer} from "./style/courierShiftTable.styled";
import {workTypes} from "constants/constants";

const {Column} = Table;

export const ShiftTable = ({courierId}) => {
    const [period, setPeriod] = useState("choose");
    const [startDate, setStartDate] = useState(
        moment()
            .subtract(7, "d")
            .toDate()
    );
    const [endDate, setEndDate] = useState(
        moment()
            .add(3, "d")
            .toDate()
    );
    const {t, i18n} = useTranslation();

    const [loading, courierShiftData, ,] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getCourierShifts.bind(null, {
            courierId,

            startDate: startDate == "" ? null : moment(startDate).format("MM-DD-YYYY"),
            endDate: endDate == "" ? null : moment(endDate).format("MM-DD-YYYY")
        }),
        dependencies: [courierId, startDate, endDate, period]
    });

    return (
        <>
            <Col xs={24} sm={20} md={16} lg={10} xl={8}>
                <DatePickerWithPeriod
                    period={period}
                    setPeriod={setPeriod}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            </Col>
            <CourierShiftTableContainer
                loading={loading}
                dataSource={courierShiftData?.result}
                rowKey="_id"
                locale={{
                    emptyText: <EmptyMessage />
                }}
            >
                <Column
                    title={t("fields.date", {ns: "common"})}
                    dataIndex="forecastDate"
                    sorter={(a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix()}
                    render={text => (
                        <span>
                            {moment(text)
                                .locale(i18n.resolvedLanguage || "tr")
                                .format("DD MMMM YYYY")}
                        </span>
                    )}
                    onCell={() => ({
                        "data-label": "Tarih"
                    })}
                />
                <Column
                    title={"Çalışma Tipi"}
                    dataIndex="workType"
                    render={workType => (
                        <span>{workTypes.find(type => type.value === workType)?.name}</span>
                    )}
                    onCell={() => ({
                        "data-label": "Çalışma Tipi"
                    })}
                />
                <Column
                    title={t("fields.city", {ns: "common"})}
                    dataIndex="city"
                    render={text => <span>{text.capitalize()}</span>}
                    onCell={() => ({
                        "data-label": "Şehir"
                    })}
                />
                <Column
                    title={"Havuz/Firma"}
                    dataIndex="poolName"
                    render={(poolName, record) => (
                        <span>{poolName ? poolName : record.companyName}</span>
                    )}
                    onCell={() => ({
                        "data-label": "Havuz/Firma"
                    })}
                />
                <Column
                    title={t("fields.subcompany", {ns: "common"})}
                    dataIndex="subcompanyName"
                    render={subcompanyName => <span>{subcompanyName}</span>}
                    onCell={() => ({
                        "data-label": "Alt Firma"
                    })}
                />
                <Column
                    dataIndex="shiftStartTime"
                    title={t("shiftScore.scheduledShift", {ns: "shiftScore"})}
                    render={(shiftStartTime, row) => (
                        <span data-testid="date">
                            {[
                                moment(row?.shiftStartTime)
                                    .locale(i18n.resolvedLanguage || "tr")
                                    .format("HH:mm"),
                                moment(row?.shiftEndTime)
                                    .locale(i18n.resolvedLanguage || "tr")
                                    .format("HH:mm")
                            ].join(" - ")}
                        </span>
                    )}
                    onCell={() => ({
                        "data-label": "Planlanan Vardiya"
                    })}
                />
            </CourierShiftTableContainer>
        </>
    );
};
